<div class="cf-templates-rem-dialog">
  @if(spinBool){
    <div class="spinner-overlay">
      <owc-progress-spinner size="xxLarge" value="50" />
    </div>
  }

  <h3>New Reminder</h3>

  <h3 style="font-weight: 500;color: #333333;margin: 0px;">Templates</h3>

  <div class="import-dialog-content">
    <dl-reminder-message-templete [isNewFromTemplate]="isNewFromTemplate" [addRowData]="newReminderTemplate" [displayedColumns]="templateColumn" [tableData]="templateData" *ngIf="templateData.length > 0" (isFeedbackOptionAdded)="feedbackOptionAdded($event)" (isReminderRowSelected)="getSelectedRowInTemplate($event)" ></dl-reminder-message-templete>
  </div>

  <div class="import-dialog-actions" style="display: flex; gap: 24px; justify-content: end; margin-top: 16px; align-items: flex-end;">
    <owc-button (click)="onCancel()" class="cancel-btn">Cancel</owc-button>
    <div style="display: flex; gap: 24px;">
      <owc-button (click)="addReminderMessage(true)" class="btn-add-reminder">
        Create from blank
      </owc-button>
      <owc-modal-dialog #modalDialogElement [(ngModel)]="visible" size="medium">
        <dl-create-reminder  [data]="data"
        (dialogClose)="handleReminderClose($event)"></dl-create-reminder>
      </owc-modal-dialog>
      <owc-button (click)="addTemplateToForm()" color="primary" [disabled]="isAffBtnDisabled">
        Continue
      </owc-button>
    </div>
  </div>
</div>
  